<div id="add-to-bookmarks" (click)="addToBookmarks()">
  <ion-icon name="bookmark"></ion-icon>
</div>
